/**
 * 데이터 문자열의 `백틱` 구간만 코드로 그린다. 온보딩 문구에는 명령·파일명이 섞이는데,
 * 이것 하나 때문에 마크다운 렌더러를 끌어오면 데이터가 문서가 되어 버린다 — 표기는 여기까지만 지원한다.
 */
export function Prose({ text }: { text: string }): React.JSX.Element {
  const parts = text.split(/`([^`]+)`/g);
  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <code key={index} className="rounded bg-line-soft px-1 font-mono text-[0.92em] text-ink">
            {part}
          </code>
        ) : (
          part
        ),
      )}
    </>
  );
}
